import { AccountCategoryCode } from '@account-users/account/models';
import { UserRolesAndPermissionsService } from '@account-users/user/services/user-roles-and-permissions.service';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Injector,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CommandModel,
  CreateCommandParams,
  CreateWizardCommandResponse,
  CreateWizardCommand,
  CreateWizardCommandService,
} from '@account-create';
import { customAlphabet } from 'nanoid';
import { map } from 'rxjs/operators';

import {
  TrialAccountRequest,
  TrialAccountRequestFilterType,
} from '../../state/models';
import { TrialAccountsStateService } from '../../state/trial-accounts-state.service';

@Component({
  selector: 'app-trial-accounts',
  templateUrl: './trial-accounts.component.html',
  styleUrls: ['./trial-accounts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialAccountsComponent implements OnInit {
  public trialAccountsRequests$ = this.trialStateService.selectTrialRequests();
  public trialAccountsRequestsFilters$ = this.trialStateService.selectFilters();
  public trialAccountsIsLoading$ = this.trialStateService.selectIsLoading();
  public hasTrialDispenserRole$ = this.userRoleService.hasTrialDispenserRole$;

  public createWizardCommand: CommandModel<CreateWizardCommand>;
  public selectedRequest$ = this.route.fragment.pipe(map((id) => id));

  private readonly _alphabet = '1234567890abcdefghijklmnopqrstuvwxyz';
  private uuid: any;

  constructor(
    private readonly trialStateService: TrialAccountsStateService,
    private readonly userRoleService: UserRolesAndPermissionsService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly injector: Injector,
  ) {
    this.uuid = customAlphabet(this._alphabet, 16);
  }

  ngOnInit(): void {
    this.createWizardCommand = this.injector
      .get(CreateWizardCommandService)
      .build({
        onSuccess: (response: CreateWizardCommandResponse) => {
          const {
            accountId,
            entryParams: { requestId },
          } = response;
          this.trialStateService.trialRequestApprove(
            accountId,
            requestId,
            true,
          );
        },
      });

    this.trialStateService.addFilters([]);
    this.trialStateService.loadTrialRequests();
  }

  public loadTrialRequests(filters: TrialAccountRequestFilterType[]) {
    this.trialStateService.loadTrialRequests(filters);
  }

  public approve(request: TrialAccountRequest) {
    const { id, email, companyName } = request;
    const createCommand: CreateCommandParams = {
      id: this.uuid(),
      displayName: `${companyName}`.toLowerCase(),
      category: AccountCategoryCode.Trial,
      description: '',
      audiencePackageSize: 1000,
      userSeats: 1,
      adminEmail: email,
      licensePackage: AccountCategoryCode.Trial,
    };
    this.createWizardCommand.execute({ createCommand, requestId: id });
  }

  public decline(request: TrialAccountRequest) {
    this.trialStateService.trialRequestDecline(request.id);
  }
}
